import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Paper, Box, Button, Typography } from "@mui/material";
import { useUser } from '../../context/UserContext';
import { signUpHousehold } from "../../api/authService";


export default function SameHousehold() {
  const navigate = useNavigate();
  const {user} = useUser();
  const [error, setError] = useState("");
    
  const handleCancel = () => {
    navigate('/');
  };
  //const handleSubmit = () => {
  //  navigate("/ValidateOTP"); // Route to ValidateOTP
  //};
  const handleSubmit = async (e) => {
      e.preventDefault();
      let errors = {};
      // Validate Name Fields and check for existing account with same email or mobile number
      try {
        const { response, data } = await signUpHousehold( user.inputFields );
      
        console.log("Sign up New User :", data, response);
  
        if (response.ok) {
          console.log("Sign up response is good for the samehousehold :", response);          
          navigate("/ValidateOTP"); // Route to ValidateOTP        
       } else {
          setError(data.message );
        }
        
      } catch (err) {
        setError("An error occurred. Please try again.");
      }
    }

  return (
    <>
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f9f9f9"
    >
        <Paper elevation={3}>
          <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
            <Typography variant="h5" align="center" gutterBottom>
              <b>Validate Household</b>
            </Typography>
          </Paper>
    <div style={{ padding: "20px" }}>
      <Grid container direction="column" spacing={3}>
            <Grid item>
              <Typography align="left" gutterBottom>
              <div>Are you belong to the same Household with Last Name : <b> {user.existingHouseholdLastName} </b></div>               </Typography>
            </Grid>
            <Grid item>
              <Typography  align="left" gutterBottom>
                  If <b>YES</b>, continue with registration.
              </Typography>
          </Grid>
          <Grid item>
              <Typography align="left" gutterBottom>
                  If <b>NO</b>, please contact membership team at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
              </Typography>
          </Grid>
      </Grid>
      
     

      <form onSubmit={handleSubmit}>
        
        <div><br /></div>
            <Grid container spacing={2} justifyContent="center" >
              <Grid item>
                <Button variant="contained" color="primary" onClick={handleCancel} sx={{ mr: 4 }}>
                  No
                </Button>
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained" color="primary" >
                  Yes, Continue
                </Button>
              </Grid>
            </Grid>
                    
      </form>
    </div>
    </Paper>
    </Box>
    </>
  );
}
